import * as Yup from "yup";

export const validationCodeSchema = Yup.object().shape({
  item1: Yup.string().max(1).required("Code is incorrect"),
  item2: Yup.string().max(1).required("Code is incorrect"),
  item3: Yup.string().max(1).required("Code is incorrect"),
  item4: Yup.string().max(1).required("Code is incorrect"),
});
